import React, { useEffect } from 'react';
import { useDispatch, connect } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { getOrdersList } from '@utilities/order';
import Loader from '@components/Loader';
import Box from '@mui/material/Box';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Grid from '@mui/material/Grid';
import Select from '@components/Select';
import { PaymentTypes } from '@constants/common';
import { updateOrderPayment } from '@utilities/order';
import { getFormattedDate, getRoomLabelText } from '@utilities/common';
import Print from '@components/Print';
import NoDataFound from '@components/NoDataFound';
import { FILTERS, ImagesGS } from '@constants/common';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './Orders.scss';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from '@mui/material';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import EditIcon from '@mui/icons-material/Edit';
import { generatePaymentQR } from '@src/utilities/generatePaymentQR';
import UpdateOrderDialog from './UpdateOrderDialog';

const Orders = ({ orders, selectedRestaurant, isSuperAdmin }: any) => {
  const [days, setDays] = React.useState(FILTERS[0].value);
  const [isCustomRange, setIsCustomRange] = React.useState(false);
  const [startDate, setStartDate] = React.useState<Date>(() => {
    const d = new Date();
    d.setDate(d.getDate() - 2);
    return d;
  });
  const [endDate, setEndDate] = React.useState<Date>(new Date());
  const [QRDialog, setQRDialog] = React.useState(false);
  const [updateOrderDialog, setUpdateOrderDialog] = React.useState<{ isOpen: boolean; orderId: string; uoId: string; createdAtDate: any; order?: any }>({ isOpen: false, orderId: '', uoId: '', createdAtDate: new Date()?.toISOString() });
  const [QRImage, setQRImage] = React.useState('');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let params = useParams();
  const [expanded, setExpanded] = React.useState<string | false>(false);

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  // eslint-disable-next-line react-hooks/exhaustive-deps -- dispatch stable
  useEffect(() => {
    if (isCustomRange) {
      if (startDate && endDate) {
        getOrdersList('admin', params?.restaurantId, dispatch, {
          type: 'range',
          startDate,
          endDate,
        });
      }
    } else {
      getOrdersList('admin', params?.restaurantId, dispatch, days);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- dispatch stable
  }, [params?.restaurantId, days, isCustomRange, startDate, endDate]);

const handleCloseOrderDialog = (isUpdated: any) => {
  setUpdateOrderDialog({isOpen: false, orderId: '', uoId: '', createdAtDate: new Date()?.toISOString()});
  if(isUpdated){
    getOrdersList('admin', params?.restaurantId, dispatch, days);
  }
}

// const handleSelectChange = (val: any, orderId: any) => {
  //     // setSelectMap({ ...selectMap, [key]: val })
  //     console.log('----selectMap', val, orderId);
  // };

  const handleSelectBlur = (event: any) => {
    event.stopPropagation();
  };

  return (
    <div className='orderssPageWrap'>
      <Box
        style={{
          backgroundColor: 'var(--primary-light)',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: 8,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
          <Select
            key={"shgdsh"}
            className="filterDays"
            defaultValue={FILTERS[0]}
            options={FILTERS}
            onChange={(val: any) => {
              if (val?.value === 'custom') {
                setIsCustomRange(true);
              } else {
                setIsCustomRange(false);
                setDays(val?.value);
              }
            }}
          />
          {isCustomRange && (
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}>
              <DatePicker
                selected={startDate}
                onChange={(date) => {
                  if (date) setStartDate(date);
                }}
                selectsStart
                startDate={startDate}
                endDate={endDate}
                className="date-picker"
              />
              <DatePicker
                selected={endDate}
                onChange={(date) => {
                  if (date) setEndDate(date);
                }}
                selectsEnd
                startDate={startDate}
                endDate={endDate}
                minDate={startDate}
                className="date-picker"
              />
            </Box>
          )}
        </Box>
        <Button
          color='primary'
          className='btn'
          variant="outlined"
          onClick={() => navigate(`/admin/${params?.restaurantId}/pos`)}
        >
          + New Order
        </Button>
      </Box>
      {orders === undefined && <Loader />}
      {orders?.length === 0 && <NoDataFound />}
      {!!orders?.length && <div className='orderMobWrap'>
        {
          !!orders && Object.entries(orders).filter(
            ([_key, item]: any) => !!item?.isGstBill
          ).map(([key, item]: any, _index: any) => (
            <Accordion className='orderCard' key={item.orderId} expanded={expanded === key} onChange={handleChange(key)}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
                className="orderListWrap admin"
              >
                <Grid container spacing={2}>
                  <Grid item md={1} sm={2} xs={4}>
                    <img src={item?.isGstBill ? ImagesGS?.BillIcon : ImagesGS?.NonBillIcon} alt="" />
                  </Grid>
                  <Grid container item md={5} sm={6} xs={8}>
                    <Grid item xs={12}>
                      <div className='customRowTable'>
                        <span>Order#: </span>
                        {item?.orderSeqNo || item?.uoId || item?.orderId}
                      </div>
                    </Grid>
                    {item?.customerName && <Grid item xs={12}>
                      <div className='customRowTable'>
                        <span>Billing: </span>
                        {item?.customerName}
                      </div>
                    </Grid>}
                    {item?.customerPhone && <Grid item xs={12}>
                      <div className='customRowTable'>
                        <span>Guest Phone: </span>
                        {item?.customerPhone}
                      </div>
                    </Grid>}
                    <Grid item xs={12}>
                      <div className='customRowTable'>
                        <span>Bill Date: </span>
                        {getFormattedDate(item?.createdAt)}
                      </div>
                    </Grid>
                    <Grid item xs={12}>
                      <div className='customRowTable'>
                        <span>Type: </span>
                        {getRoomLabelText(item?.tableNumber?.split("-")[0], parseInt(item?.tableNumber?.split("-")[1]))}
                      </div>
                    </Grid>
                    {/* <Grid item xs={6}>
                                            <div className='customRowTable'>
                                                <span>Payment: </span>
                                                {item?.selectedPayment}
                                            </div>
                                        </Grid> */}
                  </Grid>
                  <Grid container item spacing={1} md={6} sm={4} xs={12} alignContent='center'>
                    <Grid item md={4} xs={6} onClick={handleSelectBlur}>
                      {/* {<Select
                            key={item?.orderId}
                            className="selectWrap"
                            defaultValue={item?.orderStatus}
                            options={StatusMap}
                            onChange={(val: any) => updateOrderStatus(item?.orderId, val)}
                        />} */}
                      {<Select
                        key={item?.orderId + item?.selectedPayment}
                        className="selectWrap"
                        defaultValue={{ label: item?.selectedPayment, value: item?.selectedPayment }}
                        options={PaymentTypes}
                        onChange={(val: any) => updateOrderPayment(item?.orderId, val?.value || '')}
                      />}
                    </Grid>
                    <Grid item md={4} xs={6}>
                      <Print item={item} restaurant={selectedRestaurant} />
                    </Grid>
                    {selectedRestaurant?.qrInfo && (
                        <Grid item md={4} xs={12}>
                          <Button
                            fullWidth
                            variant='outlined'
                            color='secondary'
                            className='deleteBtn'
                            onClick={async (e) => {
                              e.stopPropagation();
                              const qr = await generatePaymentQR(
                                selectedRestaurant?.qrInfo,
                                item?.totalCost,
                                item?.orderSeqNo || item?.orderId
                              );
                              setQRImage(qr);
                              setQRDialog(true);
                            }}
                          >
                            <QrCodeScannerIcon />Pay via QR
                          </Button>
                        </Grid>
                      )}
                  </Grid>
                </Grid>
                {/* <Typography sx={{ color: 'text.secondary' }}>I am an accordion</Typography> */}
              </AccordionSummary>
              <AccordionDetails>
                <Box className='cartItemsWrap' sx={{ flexGrow: 1 }}>
                  {
                    !!item?.cart && Object.entries(item?.cart).map(([keyCart, itemCart]: any, indexCart: any) => (
                      itemCart?.name && <Grid className='cartItems' key={keyCart + '-' + indexCart} container spacing={2}>
                        <Grid item xs={7} style={{ textTransform: "capitalize" }}>
                          {(itemCart?.name).replaceAll("-", " ")} ({itemCart?.selectedVariants?.label})
                        </Grid>
                        <Grid item xs={2}>
                          X {itemCart?.selected} =
                        </Grid>
                        <Grid textAlign="right" item xs={3}>
                          ₹{itemCart?.selectedVariants?.value * itemCart?.selected}
                        </Grid>
                      </Grid>
                    ))
                  }
                </Box>
                {!!item?.itemsCost && <p className='alignRight'>Items Cost: ₹{item?.itemsCost}</p>}
                {/* <p className='alignRight'>GST Charges({item?.restaurant?.gstRate}%): ₹{item?.gstBill}</p> */}
                {
                  item?.gstData && Object.keys(item?.gstData).map((gstVal: any) =>
                    {
                      if(!!item?.gstData[gstVal]){
                        return <p className='alignRight' key={gstVal}>GST({gstVal}%): ₹{item?.gstData[gstVal]}</p>
                      }
                      return null;
                    }
                  )
                }
                {!!item?.restaurant?.serviceRate && <p className='alignRight'>Service Charges({item?.restaurant?.serviceRate}%): ₹{item?.serviceBill}</p>}
                {!!item?.discount && <p className='alignRight'>Discount: ₹{item?.discount}</p>}
                <p className='alignRight'><b>Total Bill: ₹{item?.totalCost}</b></p>
                {isSuperAdmin &&
                  <Grid container spacing={2}>
                    <Grid item md={4} xs={5}>
                      <Button fullWidth variant="outlined" color='secondary' className='deleteBtn' onClick={() => setUpdateOrderDialog({ isOpen: true, orderId: item?.orderId, uoId: item?.uoId || item?.orderId, createdAtDate: item?.createdAt, order: item })}>
                        <EditIcon /> Edit
                      </Button>
                    </Grid>
                  </Grid>
                }
              </AccordionDetails>
            </Accordion>
          ))
        }
      </div>}
      <Dialog open={QRDialog} onClose={() => setQRDialog(false)}>
        {/* <DialogTitle>SCAN TO PAY</DialogTitle> */}
        <DialogContent>
        {selectedRestaurant?.qrInfo?.pn && <Typography variant="h6" sx={{fontSize: "1.2rem"}} gutterBottom align='center'>
            {selectedRestaurant?.qrInfo?.pn}
        </Typography>}
        <Typography variant='subtitle2' align='center' sx={{ fontWeight: 'bold', color: 'var(--primary)', fontSize: '1rem' }}>Scan and Pay</Typography>
          {QRImage ? <img style={{maxWidth: '100%'}} src={QRImage} alt="" /> : 'QR CODE GENERATION FAILED'}
          {selectedRestaurant?.qrInfo?.pa && <Typography variant="h6" sx={{fontSize: "1.2rem"}} gutterBottom align='center'>
            {selectedRestaurant?.qrInfo?.pa}
          </Typography>}
          {ImagesGS?.UPIIcon && <img
            src={ImagesGS?.UPIIcon}
            alt="UPI Icon"
            style={{width: '250px', margin: '0 auto', display: 'block'}}
          />}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setQRDialog(false)}>Cancel</Button>
        </DialogActions>
      </Dialog>
      {isSuperAdmin && <UpdateOrderDialog data={updateOrderDialog} onClose={(isUpdated: boolean)=>handleCloseOrderDialog(isUpdated)} />}
    </div>
  );
}

const mapStateToProps = (state: any) => {
  const { common, user } = state
  return {
    orders: common?.orders,
    selectedRestaurant: common?.selectedRestaurant,
    selectedRestId: common?.selectedRestaurant?.docId || "",
    roles: user?.user?.roles || {},
    userPermissions: user?.user?.roles ? {...common?.globalConfig?.permissions, ...(user?.user?.roles[common?.selectedRestaurant?.docId]?.permissions)} : {},
    isSuperAdmin: !!(user?.user?.isSuperAdmin),
  }
}

export default connect(mapStateToProps)(Orders);
